<template>
  <!-- <div class="col-xl-8" id="measurement"> -->
  <div id="measurement">
    <div class="portlet">
      <div class="portlet-head">
        <h3>
          <i class="fas fa-file-invoice-dollar mr-2"></i>Koszta
        </h3>
        <div>
          <button class="btn btn-sm btn-outline-primary" @click="modalBill()">
            <i class="fas fa-plus"></i> Dodaj
          </button>
        </div>
      </div>
      <div class="portlet-body">
        <b-table
          class="table table-list table-mobile bills-table m-0"
          ref="bills_table"
          :fields="fields"
          :busy.sync="isBusy"
          :items="bills"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          stacked="lg"
          show-empty
          empty-text="Brak Kosztów"
        >
          <template v-slot:table-busy>
            <TableSpiner />
          </template>
          <template v-slot:empty="{ emptyText }">
            <div class="empty">
              <i class="fas fa-money-check-alt empty-state"></i>
              <span class="empty-search">{{ emptyText }}</span>
            </div>
          </template>
          <template v-slot:cell(bills_category_name)="data">
            <div
              class="badge badge-info"
              v-if="data.item.bills_category_id !== 2"
            >{{ data.item.bills_category_name }}</div>
            <div class="badge badge-secondary" v-else>{{ data.item.subcontractor.text || "Brak"}}</div>
          </template>
          <template v-slot:cell(split_amount)="data">
            <div v-if="data.item.currency !== getMainBaseCurrency">
              {{ abc = parseFloat(findSplitAmount(data.item.construction)/data.item.exchange_rate).toFixed(2) }}
              <br/><small class="exhange-info">{{ findSplitAmount(data.item.construction) }}</small>
            </div>
            <div v-else>
              {{ findSplitAmount(data.item.construction) }}
            </div>
          </template>
          <template v-slot:cell(currency)="data">
            <div v-if="data.item.currency !== getMainBaseCurrency">
              {{getMainBaseCurrency}}
              <br/><small class="exhange-info">{{ data.item.currency }}</small>
            </div>
            <div v-else>
              {{ data.item.currency }}
            </div>
          </template>
          <template v-slot:cell(split_note)="data">
            <span v-html="findSplitNote(data.item.construction)"></span>
          </template>

          <template v-slot:cell(options)="data">
            <div class="text-right text-lg-center">
              <b-dropdown no-caret right variant="light" class="btn-rounded">
                <template v-slot:button-content>
                  <i class="fas fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item-button @click="modalBill(data.item.id)">Edytuj</b-dropdown-item-button>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item-button class="danger" @click="confirmRemove(data.item)">
                  <i class="fas fa-trash-alt"></i> Usuń
                </b-dropdown-item-button>
              </b-dropdown>
            </div>
          </template>
        </b-table>
      </div>
    </div>
    <BillsModalForm :bill="this.selected" @onClose="onClose" @onSubmit="onSubmit" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import BillsModalForm from "@/components/bills/BillsModalForm";
import TableSpiner from "@/components/TableSpiner";

export default {
  name: "BillsConstructionPortlet",
  components: { BillsModalForm, TableSpiner },
  props: {
    construction: {
      type: Object
    }
  },
  computed: {
    ...mapGetters("bills", ["bills"]),
    ...mapGetters("company", ["getMainBaseCurrency"]),
  },
  data() {
    return {
      selected: {},
      isBusy: false,
      sortBy: "issue_date",
      sortDesc: false,
      fields: [
        { key: "bills_category_name", label: "Kategoria", sortable: true },
        { key: "issue_date", label: "Data wystawienia", sortable: true },
        { key: "number", label: "RE Nr" },
        { key: "split_amount", label: "Suma", class: "text-right" },
        { key: "currency", label: "Waluta", class: "text-right" },
        { key: "split_note", label: "Notka", class: "text-right" },
        { key: "options", label: "Opcje", class: "text-center" }
      ]
    };
  },
  created() {},
  methods: {
    ...mapActions("bills", ["unattachBill"]),
    findSplitNote(construction) {
      let split = this.$_.find(construction, { value: this.construction.id });
      if (split) {
        return split.note;
      }
      return "";
    },
    findSplitAmount(construction) {
      let split = this.$_.find(construction, { value: this.construction.id });
      if (split) {
        if (parseFloat(split.amount) === 0) {
          return '<span class="text-danger">' + split.amount + "</span>";
        } else {
          return split.amount;
        }
      }
      return "";
    },
    onClose() {
      this.selected = {};
    },
    onSubmit() {
      this.$refs.bills_table.refresh();
      this.recalculateCost();
      this.$nextTick(() => {
        this.$bvModal.hide("bill-modal");
      });
    },
    modalBill(bill_id) {
      if (bill_id) {
        this.selected = this.$_.find(this.bills, { id: bill_id });
      } else {
        this.selected = {
          construction: [
            {
              amount: "",
              note: "",
              pur: this.construction.pur,
              text: this.construction.name,
              value: this.construction.id
            }
          ]
        };
      }
      this.$nextTick(() => {
        this.$bvModal.show("bill-modal");
      });
    },
    confirmRemove(bill) {
      let split = this.$_.find(bill.construction, {
        value: this.construction.id
      });
      let h = this.$createElement;
      this.$bvModal
        .msgBoxConfirm(
          [
            h("p", [
              "Czy napewno chcesz usunąć koszt ",
              h("strong", split.amount + " " + bill.currency),
              " z rachunku o numerze ",
              h("br"),
              h("strong", bill.number),
              " ?"
            ])
          ],
          {
            title: "Potwierdź usunięcie kosztu",
            okVariant: "danger",
            okTitle: "TAK",
            cancelTitle: "NIE"
          }
        )
        .then(result => {
          if (result !== true) {
            return;
          }
          this.$Progress.start();
          this.unattachBill({
            constructionid: this.construction.id,
            billid: bill.id
          }).then(() => {
            this.recalculateCost();
            this.$refs.bills_table.refresh();
          });
        });
    },
    recalculateCost() {
      let costSubcontractors = 0,
        costMaterials = 0;
      this.$_.each(this.bills, bill => {
        let cost = this.$_.find(bill.construction, {
          value: this.construction.id
        });
        if (cost) {
          if (bill.bills_category_id === 2) {
            if(bill.exchange_rate === 0){
              costSubcontractors += parseFloat(cost.amount);
            }else{
              costSubcontractors += parseFloat(cost.amount)/parseFloat(bill.exchange_rate);
            }
          } else {
            if(bill.exchange_rate === 0){
              costMaterials += parseFloat(cost.amount);
            }else{
               costMaterials += parseFloat(cost.amount)/parseFloat(bill.exchange_rate);
            }
          }
        }
        this.$store.commit(
          "construction/costSubcontractors",
          costSubcontractors
        );
        this.$store.commit("construction/costMaterials", costMaterials);
      });
    }
  }
};
</script>